import ApiBase from './ApiBase';

export default class CdusService extends ApiBase {
  async createFrame(payload) {
    const { data } = await this.client.post('', payload);

    return data;
  }

  async fetchOne(frameId) {
    const { data } = await this.client.get(`/${frameId}`);

    return data;
  }

  async updateFrame({ frameId, payload }) {
    const { data } = await this.client.put(`/${frameId}`, payload);

    return data;
  }
}
